import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Directive } from '@angular/core';

import { map, Observable, switchMap } from 'rxjs';

import { ReadableDatePipe } from '../../../../pipes/readable-date-pipe';
import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { DownloadRow } from '../../../entities/download-row.entity';

export interface DownloadDate {
    readonly raw: string;
    readonly readable: string;
}

@Directive()
export abstract class DownloadDateCellComponent extends BaseColumnComponent<DownloadRow> {
    readonly date$: Observable<DownloadDate>;

    protected constructor(readableDatePipe: ReadableDatePipe, cd: ChangeDetectorRef) {
        super(cd);

        this.date$ = this.data$.pipe(
            switchMap(row => this.select(row)),
            map(raw => ({ raw, readable: readableDatePipe.transform(raw, true) }))
        );
    }

    protected abstract select(row: DownloadRow): Observable<string>;
}

@Component({
    standalone: false,
    selector: 'digihaven-download-creation-date-cell',
    templateUrl: './download-date-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadCreationDateCellComponent extends DownloadDateCellComponent {
    constructor(readableDatePipe: ReadableDatePipe, cd: ChangeDetectorRef) {
        super(readableDatePipe, cd);
    }

    protected select(row: DownloadRow): Observable<string> {
        return row.downloaddatum$;
    }
}

@Component({
    standalone: false,
    selector: 'digihaven-download-expiry-date-cell',
    templateUrl: './download-date-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadExpiryDateCellComponent extends DownloadDateCellComponent {
    constructor(readableDatePipe: ReadableDatePipe, cd: ChangeDetectorRef) {
        super(readableDatePipe, cd);
    }

    protected select(row: DownloadRow): Observable<string> {
        return row.vervaldatum$;
    }
}
